module.exports = __webpack_public_path__ + "static/media/IMG_20190130_112850853.72799473.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_20190130_112850853.jpg
// module id = 47
// module chunks = 0